import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function usePromos(pollMs = 30000) {
  const [promos, setPromos] = useState({});

  useEffect(() => {
    const refresh = async () => {
      try {
        const { data } = await axios.get(`${API}/promos`);
        setPromos(data || {});
      } catch {
        setPromos({});
      }
    };
    refresh();
    if (!pollMs) return;
    const t = setInterval(refresh, pollMs);
    return () => clearInterval(t);
  }, [pollMs]);

  return promos;
}
